import Sortable, { SortableEvent } from "sortablejs";
import { DotNetComponent } from "../../typings/global";

export function initSort(
	id: string,
	group: string,
	pull: boolean | string = true,
	put: boolean | string = false,
	sort = true,
	handle?: string,
	filter?: string,
	component?: DotNetComponent,
	forceFallback?: boolean
): void {
    console.log(`Initializing Sortable on element with id '${id}'`);
    
	const element = document.getElementById(id);
	if (!element) {
		console.warn(`Element with id '${id}' not found.`);
		return;
	}

	new Sortable(element, {
		animation: 200,
		group: {
			name: group,
			pull: pull ?? true,
			put: put
		},
		filter: filter ?? undefined,
		sort,
		forceFallback,
		handle: handle ?? undefined,

		onUpdate: (event: SortableEvent) => {
			if (!component) return;

			// Revert DOM to match .NET state
			event.item.remove();
			event.to.insertBefore(event.item, event.to.childNodes[event.oldIndex!]);

			// Notify .NET to update its model
			component.invokeMethodAsync("OnUpdateJS", event.oldDraggableIndex, event.newDraggableIndex);
		},

		onRemove: (event: SortableEvent) => {
			if (!component) return;

			if ((event as any).pullMode === "clone") {
				event.clone?.remove();
			}

			event.item.remove();
			event.from.insertBefore(event.item, event.from.childNodes[event.oldIndex!]);

			component.invokeMethodAsync("OnRemoveJS", event.oldDraggableIndex, event.newDraggableIndex);
		}
	});
}
